// cartReducer.js

import { ADD_TO_CART, REMOVE_FROM_CART, CLEAR_CART, UPDATE_TOTAL_AMOUNT } from '../actions/cartActions';

const initialState = {
  items: [],
  totalAmount: 0,
};

const cartReducer = (state = initialState, action) => {
  switch (action.type) {
    case ADD_TO_CART:
      const existingItem = state.items.find(item => item.id === action.payload.id);
      let updatedItems;
      let updatedTotalAmount;

      const priceToAdd = parseFloat(action.payload.price_after_discount) || parseFloat(action.payload.price_before_discount);

      if (existingItem) {
        // If the item exists, increase its quantity
        updatedItems = state.items.map(item =>
          item.id === action.payload.id
            ? { ...item, quantity: item.quantity + 1 }
            : item
        );
        updatedTotalAmount = state.totalAmount + priceToAdd;
      } else {
        // If the item doesn't exist, add it with quantity 1
        updatedItems = [...state.items, { ...action.payload, quantity: 1 }];
        updatedTotalAmount = state.totalAmount + priceToAdd;
      }

      return {
        ...state,
        items: updatedItems,
        totalAmount: updatedTotalAmount,
      };

    case REMOVE_FROM_CART:
      const itemToRemove = state.items.find(item => item.id === action.payload);
      const newItems = state.items.filter(item => item.id !== action.payload);
      const priceToRemove = parseFloat(itemToRemove.price_after_discount) || parseFloat(itemToRemove.price_before_discount);
      const newTotalAmount = state.totalAmount - priceToRemove;
      
      return {
        ...state,
        items: newItems,
        totalAmount: newTotalAmount,
      };

    case CLEAR_CART:
      return {
        ...state,
        items: [],
        totalAmount: 0,
      };

      case UPDATE_TOTAL_AMOUNT:
      return {
        ...state,
        totalAmount: action.payload,
      };

    default:
      return state; // Ensure you return the state for unknown actions
  }
};

export default cartReducer;
